import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES

// TYPES
import { ReducerAction } from 'store/modules/types';
import { PATH_SERVICOS_PREFEITURAS_API } from 'services/rotasp/path';
import { postApi } from 'services/rotasp/api';
import { Types } from './types';

// ACTIONS
import {
	cadastraPrefeiturasServicosValidacoesFailure,
	cadastraPrefeiturasServicosValidacoesSuccess,
	IPrefeiturasServicosValidacoes,
} from './actions';

function* cadastraPrefeiturasServicosValidacoes(request: ReducerAction) {
	const {
		token = '',
		payload,
	}: { token?: string; payload: IPrefeiturasServicosValidacoes } = request;

	const headerComplement = {
		dimensaoPdf: 'A4',
	};

	const response = yield call(
		postApi,
		token,
		PATH_SERVICOS_PREFEITURAS_API,
		`servicos/${payload.idPrefeituraServico}/padronizados`,
		payload.body,
		headerComplement,
	);

	if (response.status === 200) {
		yield put(cadastraPrefeiturasServicosValidacoesSuccess(response));
	} else if (response.status === 204) {
		yield put(cadastraPrefeiturasServicosValidacoesFailure({}));
	}
}

export default all([
	takeLatest(
		Types.CADASTRA_PREFEITURAS_SERVICOS_VALIDACOES,
		cadastraPrefeiturasServicosValidacoes,
	),
]);
